import { observer } from "mobx-react";
import { WeaRichText } from 'ecCom';
import React from 'react';

export interface MainProps{
    fieldName:string;
    path?:string;
    field:any;
    viewAttr:Number;
    extentsConfig:any;
    onToolsChange:any;
    ckConfig:any
}

@observer
export default class Main  extends React.Component<MainProps, any> {

    render(){
        const {fieldName,  field, viewAttr, extentsConfig, onToolsChange, ckConfig,} = this.props;
        const bind = field.bind();
        return (
            <div style={{ position: "relative", width: '89%', fontSize: '12px' }} className={`cube-card-weaRichtext ${viewAttr == 3 && !bind.value ? 'required' : ''}`}>
                <WeaRichText
                    ckConfig={ckConfig}
                    id={fieldName}
                    ref={`${fieldName}`}
                    {...bind}
                    viewAttr={2}
                    scrollContainer='.wea-new-top-req-content'
                    extentsConfig={extentsConfig}
                    onToolsChange={onToolsChange}
                    // key={field.id}   //这个key暂时处理了保存的e问题，但是出现两次闪烁的问题，等组件改了在改回去
                />
                <input type="hidden" id={fieldName} name={fieldName} value={bind.value} />
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ../src4js/pc4mobx/cube/src/components/excel-layout/cell-field/textarea-element/RichText.tsx